$(document).ready(function(){
  $(".wtsp_open").click(function(){
    $(".cd_wtsp").addClass('active');
  });
  $(".insta_open").click(function(){
    $(".cd_insta").addClass('active');
  });
  $(".linkding_open").click(function(){
    $(".cd_linkdin").addClass('active');
  });
  $(".facebook_open").click(function(){
    $(".cd_faceb").addClass('active');
  });
   $("li.site-nav__item.site-nav__expanded-item:last-child").click(function(){
    $(".retailer_rg_form").addClass('active');
      $(".li.site-nav__item.site-nav__expanded-item:last-child").addClass('active');
     
  });
  $(".wtsp-close-icon, .insta-close-icon, .linkdin-close-icon, .faceb-close-icon").click(function(){
    $(".cd_faceb, .cd_linkdin, .cd_wtsp, .cd_insta").removeClass('active');
  });
});

$(document).ready(function () {
    if (window.location.href.includes("https://littofficial.com/account/login?checkout_url=https://littofficial.com/pages/retaile")) {
        $("body").addClass("cretae-login-option-hide");
    }
});
$(document).ready(function () {
    if (window.location.href.includes("littofficial.com/account/login?return_url=%2Faccount")) {
        $("body").addClass("regitraion-option-hide");
    }
});